export default __webpack_public_path__ + "static/media/093-diagonal-arrow-10.83298670.png";